import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFirstPartInactive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 14,
		cy: 14,
		r: 14,
		fill: "#EBEBEB"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13.5724 18.07C13.5724 18.0133 13.5724 17.9467 13.5724 17.87C13.5724 17.7933 13.5724 17.7133 13.5724 17.63C13.5724 17.5467 13.5724 17.465 13.5724 17.385C13.5757 17.305 13.579 17.2317 13.5824 17.165V17.17C13.5857 17.01 13.5874 16.845 13.5874 16.675C13.5907 16.5017 13.5924 16.32 13.5924 16.13C13.5924 15.7633 13.5874 15.3833 13.5774 14.99C13.5707 14.5967 13.5474 14.1883 13.5074 13.765C13.4674 13.3383 13.4057 12.8983 13.3224 12.445C13.239 11.9883 13.1207 11.515 12.9674 11.025L14.1324 10.645C14.3024 11.1883 14.434 11.71 14.5274 12.21C14.624 12.7067 14.694 13.1833 14.7374 13.64C14.784 14.0933 14.8124 14.5283 14.8224 14.945C14.8324 15.3617 14.8374 15.7617 14.8374 16.145C14.8374 16.335 14.8357 16.5183 14.8324 16.695C14.8324 16.8683 14.8307 17.035 14.8274 17.195C14.824 17.2617 14.8207 17.335 14.8174 17.415C14.8174 17.4917 14.8174 17.57 14.8174 17.65C14.8174 17.73 14.8174 17.8067 14.8174 17.88C14.8174 17.9533 14.8174 18.0167 14.8174 18.07H13.5724Z",
		fill: "#A0A0A0"
	})]
});
export default SvgFirstPartInactive;
